import {state} from 'dicts/leads';
import {fullAddress} from 'utils/buildings';
import {fullName} from 'utils/people';

export const getLeadEncounterState = lead => {
	if (lead.encounterState === 'contacted' && lead.encounterType === 'salesmanVisit') {
		return 'Not offered';
	}

	return state[lead.encounterState] || '';
};

export const getShortUrl = url => {
	if (!url) return '';

	if (url.includes('/')) {
		try {
			const _url = new URL(url);
			return _url.pathname.replace(/^\/|\/$/g, '');
		} catch (e) {
			return url;
		}
	}

	return url;
};

export const getLeadBuildingAddress = lead => {
	const b = lead.building || {address: lead.address, city: lead.city, zip: lead.zip};
	return b.address || b.city || b.zip ? fullAddress(b) : '-';
};

export const getLeadClientName = lead => {
	const c = lead.client || {
		firstName: lead.clientFirstName,
		lastName: lead.clientLastName,
	};

	return c.firstName || c.lastName ? fullName(c) : '-';
};
export const getLeadClientEmail = lead => {
	return lead.client?.email || '-';
};
